import MovingImage from "./components/MovingImage";
import Layout from "./Layout";

const About = () => {
    return (
        <Layout>
            <div className="text-[#0a1a42]">

                <div className="px-4 pt-8 flex flex-col place-items-center md:justify-center md:flex-row">
                    <div className="w-full md:w-2/3 ">
                        <h1 className="text-2xl font-bold text-center font-roboto">
                            About Us
                        </h1>
                        <h2>
                            Divine Royal international college (DRIC) is a Christian private
                            boarding secondary school situated east of the Niger. We are glad you
                            could make it to our website today. From Background and history, to
                            curriculums, to our drivers, keep scrolling through to get more
                            information about us.
                        </h2>
                        <button>Get Started</button>
                    </div>

                    <div>
                        <img
                            src="/schoolweb/Collegeicon.webp"
                            alt=""
                            className="w-1/3 md:w-1/2 mx-auto"
                        />
                    </div>
                </div>

                


                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-[#0a1a42]">
                    {/* Card 1 */}
                    <div className="bg-white rounded-lg shadow-md p-4">
                        <h1 className="text-2xl font-bold mb-2">Our Motto</h1>
                        <p>
                            “Light of the World“ At DRIC, We desire to be “Pace Setters” and
                            model instruments in the hand of God both in secular and spiritual
                            endeavors, to show the light in character, and spiritual discipline.
                        </p>
                    </div>

                    {/* Card 2 */}
                    <div className="bg-white rounded-lg shadow-md p-4">
                        <h1 className="text-2xl font-bold mb-2">Our Mission</h1>
                        <p>
                            At DRIC, We are committed to producing the total child in
                            character and learning through the provision of qualitative
                            formal education combined with the right Christian ethics and
                            principles.
                        </p>
                    </div>

                    {/* Card 3 */}
                    <div className="bg-white rounded-lg shadow-md p-4">
                        <h1 className="text-2xl font-bold mb-2">
                            Our Vision</h1>
                        <p>
                            To provide a stimulating and conducive environment where students
                            can identify and achieve their potential, become torchbearers in
                            moral and academic disposition, and become drivers of positive change
                            in their generation.
                        </p>
                    </div>
                </div>



                <div class="bg-gray-100 mx-8 mt-24">
                    <section class="bg-white py-10 ">
                        <div class="container mx-auto text-center">
                            <h2 class="text-3xl text-center font-bold mb-6">Our Achievements</h2>


                            <div class="md:flex md:justify-center md:items-center space-y-4">

                                <div class="bg-white shadow-md rounded-lg p-6 mr-4">
                                    <h3 class="text-xl font-semibold mb-2">International Achievements</h3>
                                    <ul class="list-disc list-inside text-gray-700">
                                        <li>In 2014, DRIC participated in a Mathematics Competition organized by the Mathematics Association of Nigeria (MAN) DRIC Emerged First in the Junior Category.</li>
                                        <li>In February 2015 DRIC was given a rare slot to participate in the COBIS World Debate in Bucharest, Romania, and despite the short notice, we emerged in the third position.</li>
                                        <li>In February 2016, DRIC was given another slot to participate in the COBIS World Debate in Mexico, and we emerged in 2nd position.</li>
                                    </ul>
                                </div>

                                <div class="bg-white shadow-md rounded-lg p-6 ml-4">
                                    <h3 class="text-xl font-semibold mb-2">National Achievements</h3>
                                    <ul class="list-disc list-inside text-gray-700">
                                        <li>37th Top Secondary School in Nigeria enlisted by the West African Examination Council (WAEC)</li>
                                        <li>1st position in a science Quiz Competition organized by the University of Ibadan, Alumni Association Anambra State Branch</li>
                                        <li>2nd position in a science Quiz competition organized by the National institute of physics</li>
                                        <li>2nd position in the South-East level of NNPC organized a science Quiz competition</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <div>
                    <MovingImage />
                </div>

            </div>



        </Layout>
    );
}

export default About;